export const STATIC_PARTY_LABELS = Object.freeze({
  payer: 'Payer',
  recipient: 'Recipient',
  debtor: 'Debtor',
  creditor: 'Creditor',
  debtor_account: 'Debtor Account',
  creditor_account: 'Creditor Account',
  ultimate_debtor: 'Ultimate Debtor',
  ultimate_creditor: 'Ultimate Creditor',
});
